import { Card } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { ESTADO_PLUGIN, fecha } from './formato'

/** Pestaña «Solicitudes»: los plugins a medida que se pidieron para esta empresa. */
export default function Solicitudes({ ficha }) {
  const sols = ficha.solicitudes || []
  if (sols.length === 0) return <Card className="p-6 text-center text-neutral-500 dark:text-neutral-400">Sin solicitudes de plugin.</Card>
  return (
    <div className="space-y-3">
      {sols.map((s) => {
        const est = ESTADO_PLUGIN[s.status] || { label: s.status, variant: 'secondary' }
        return (
          <Card key={s._id} className="p-4">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="font-medium text-neutral-900 dark:text-neutral-50">{s.titulo}</p>
                <p className="text-caption text-neutral-500 dark:text-neutral-400">{fecha(s.createdAt)} · prioridad {s.prioridad || 'media'}</p>
                {s.adminNotes && <p className="text-caption text-neutral-600 dark:text-neutral-400 mt-1">{s.adminNotes}</p>}
              </div>
              <Badge variant={est.variant}>{est.label}</Badge>
            </div>
          </Card>
        )
      })}
    </div>
  )
}
